<template>
  <div>
    <div class="buttons-wrapper">
      <button
        v-for="(button, i) in buttons"
        :key="`btn-${button.label}`"
        :class="button.activated ? 'activated' : 'desactivated'"
        :style="button.activated ? { color: color } : ''"
        :disabled="button.disabled"
        @click="() => changeButton(i)"
      >
        {{ button.label }}
      </button>
    </div>
    <div v-if="buttons[0].activated">
      <div
          v-if="!hasCurriculum"
          class="text-center"
      >
        <p>
          Você ainda não adicionou o currículo!
        </p>
        <vs-button
          color="primary"
          type="filled"
          @click="$router.push({ name: 'edit-curriculumn' })"
          class="mt-5"
        >Envie seu Currículo</vs-button>
      </div>
      <div v-else>
        <div v-if="isLoadingSimilar || similars.length > 0" class="mb-5 text-center">
          <vs-label>
            {{
              isLoadingSimilar
                ? `Com base no seu perfil, estamos buscando oportunidades para você!`
                : `Com base no seu perfil, encontramos na Recrutei essas oportunidades para você`
            }}
            </vs-label>
        </div>
        <div v-if="isLoadingSimilar" class="similar-loading-container">
          <video :src="similarLoadingVideo" autoplay loop  muted playsinline webkit-playsinline width="212" height="182"></video>
          <div class="similar-loading-percentage">{{similarLoadingSteps[similarLoadingStep-1].percentage}}%</div>
          <div class="similar-loading-bar">
            <div class="similar-loading-bar-fill" :style="{ width: `${similarLoadingSteps[similarLoadingStep-1].percentage}%` }"></div>
          </div>
          <div class="similar-loading-text">{{similarLoadingSteps[similarLoadingStep-1].text}}</div>
        </div>
        <VacancyEmptyCard
            v-if="!isLoadingSimilar && !similars.length > 0 && similars_error"
            title="Não foi possível carregar as vagas"
            description="Parece que ocorreu uma falha ao carregar as vagas, tente atualizar a página ou aperte Ctrl+F5, se o problema persistir tente novamente mais tarde."
        />
        <VacancyEmptyCard
            v-else-if="!isLoadingSimilar && !similars.length > 0 && !similars_error"
            title="Por enquanto, não foi possível encontrar nenhuma sugestão de vaga para você"
            description="Se você acabou de enviar seu Currículo, aguarde alguns instantes, e depois, tente novamente!"
        />
        <div v-else-if="similars.length > 0">
          <div v-for="similar in similars" :key="`similar-${similar.id}`">
            <VacancySimilarCard
              :vacancy="similar"
              :isOpen="true"
              class="mobile-hidden"
            />
            <VacancySimilarMobileCard
              :vacancy="similar"
              :isOpen="true"
              class="sm:hidden"
            />
          </div>
          
          <vs-pagination
            class="mt-5 mb-10"
            :total="similar_pagination_total"
            v-model="similar_pagination_current"
          />
        </div>
      </div>
    </div>
    <vs-collapse v-else>
      <div style="text-align:center;">
        <img
          width="250px"
          src="https://recrutei-website.s3.sa-east-1.amazonaws.com/assets/image/png/4136684-min.png"
        />
      </div>

      <div class="portal-title">
        Portal de Oportunidades
      </div>
      <div class="portal-description">
        A Recrutei é uma empresa de tecnologia, que busca oferecer a melhor
        experiência em recrutamento e seleção para empresas e candidatos. Nosso
        propósito sempre foi impactar diretamente na geração de empregos no
        Brasil, e diariamente milhares de pessoas encontram a tão esperada
        oportunidade utilizando nossa tecnologia. Por conta disso,
        disponibilizamos além das vagas as quais você se interessou, outras
        oportunidades para quem está buscando mudança, seja porque está
        desempregado ou porque busca um emprego melhor.
      </div>

      <!-- <div class="portal-question">
        Se você se encaixa nesse contexto que descrevemos acima, e gostaria de
        ser encontrado por diversas empresas além dessa para qual se candidatou,
        aceite o termo abaixo, e seu perfil entrará na base comum da Recrutei,
        podendo ser visualizado por mais de 2 mil recrutadores diariamente.
      </div> -->

      <div class="portal-question">
        Por conta do contexto que descrevemos acima, somente com um cadastro em 
        nossos sistemas, seu perfil já passou a ser visto por milhares de recrutadores
        diariamente. Caso deseje que somente a empresa para a qual se aplicou tenha
        acesso aos seus dados de perfil, clique no botão abaixo "Cancelar Inscrição".
        Isso não irá remover sua candidatura da vaga, somente a visualização pública
        do seu perfil para empresas de todo o Brasil.
      </div>


      <div class="checkboxes">
        <div class="checkbox-group">
          <input type="checkbox" class="checkbox" v-model="is_public" />
          <span>Desejo ser visualizado por todas as empresas da Recrutei.</span>
        </div>
        <span v-if="is_public_error" class="checkbox-danger"
          >Clique no quadro para informar que está de acordo</span
        >
        <div class="checkbox-group">
          <input type="checkbox" class="checkbox" v-model="receive_email" />
          <span>Desejo receber oportunidades por email e telefone.</span>
        </div>
      </div>
      <span v-if="receive_email_error" class="checkbox-danger"
        >Clique no quadro para informar que está de acordo</span
      >

      <div class="button-group">
        <vs-button color="primary" type="filled" @click="onSubmit"
          >Salvar configurações</vs-button
        >

        <vs-button color="primary" type="border" @click="openNewTab">
          Ver Outras Vagas Disponíveis
        </vs-button>

        <vs-button color="primary" type="border" @click="openNewTabTelegram">
          Grupo de Vagas no Telegram
        </vs-button>

        <!-- <vs-button color="primary" type="border" @click="openNewTabSearch">
          Pesquisa sobre Experiência de Cadastro
        </vs-button> -->

        <br><hr><br>
        <vs-button color="danger" type="border" @click="onCancel"
          >Cancelar Inscrição na Base Recrutei</vs-button
        >
      </div>

      <div>
        <small>
          Ao aceitar os termos e salvar as configurações, você passará a ser
          visto numa base compartilhada da Recrutei.
          <br />Ao clicar em "Cancelar Inscrição" você sairá da "Base Recrutei" 
          e somente a empresa para qual se aplicou na vaga poderá ver seu perfil.
          <br />Recrutadores não poderão visualizar suas informações de contato.
          Somente experiências, formações, currículo e dados cadastrais. <br />Saiba mais sobre a
          <a target="_blank" href="https://recrutei.com.br">Recrutei</a>.
        </small>
      </div>
    </vs-collapse>
  </div>
</template>

<script>
import { get } from "lodash";
import similarLoadingVideo from "@/assets/animations/re-digitando.mp4";
import VacancySimilarCard from "../../components/dashboard/VacancySimilarCard.vue";
import VacancySimilarMobileCard from "../../components/dashboard/VacancySimilarMobileCard.vue";
import VacancyEmptyCard from "../../components/dashboard/profile-detail/VacancyEmptyCard.vue";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("company", ["company"]),
    hasCurriculum() {
      return this.basicInfo.curriculum_url ? true : false;
    },
    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
  },
  data: () => ({
    is_public: false,
    is_public_error: false,
    receive_email: false,
    receive_email_error: false,
    isLoadingSimilar: false,
    similars: [],
    similars_error: false,
    similar_total: 0,
    similar_pagination_total: 1,
    similar_pagination_current: 1,
    similar_pagination_path: "",
    similarLoadingVideo,
    similarLoadingStep: 1,
    similarLoadingInterval: null,
    similarLoadingMinimumTime: 6000,
    similarLoadingSteps: [
      {
        percentage: 1,
        text: "Analisando seus detalhes profissionais",
      },
      {
        percentage: 20,
        text: "Verificando a sua localidade",
      },
      {
        percentage: 40,
        text: "Revisando suas formações",
      },
      {
        percentage: 60,
        text: "Avaliando suas experiências",
      },
      {
        percentage: 80,
        text: "Examinando suas habilidades",
      },
      {
        percentage: 100,
        text: "Buscando vagas",
      },
    ],
    buttons: [
        {
          label: "Vagas para você",
          activated: true,
          disabled: false,
        },
        {
          label: "Seja Encontrado(a)",
          activated: false,
          disabled: false
        },
      ],
  }),
  watch: {
    is_public(value) {
      if (value) this.is_public_error = false;
    },
    receive_email(value) {
      if (value) this.receive_email_error = false;
    },
    similar_pagination_current(page) {
      this.fetchSimilarPagination(page);
    },
    isLoadingSimilar(value) {
      if (value) {
        if (this.intervalId !== null) {
          clearInterval(this.intervalId);
        }
        this.intervalId = setInterval(() => {
          if (this.similarLoadingStep < this.similarLoadingSteps.length) {
            this.similarLoadingStep++;
          } else {
            this.similarLoadingStep = 1;
          }
        }, this.similarLoadingMinimumTime / this.similarLoadingSteps.length);
      } else {
        if (this.intervalId !== null) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
    },
  },
  methods: {
    async onSubmit() {
      if (!this.is_public) this.is_public_error = true;
      if (!this.receive_email) this.receive_email_error = true;

      if (this.is_public && this.receive_email) {
        try {
          this.loading = true; // Ativar o loading
          await this.$http.post("api/v2/talents/public/set-public");
          this.$vs.notify({
            title: "Parabéns!",
            text: "Agora você faz parte da Base Recrutei!",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success"
          });
        } catch (error) {
          this.$vs.notify({
            title: "Ops!",
            text: error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        } finally {
          this.loading = false; // Desativar o loading
        }
      }
    },
    async fetchPublicStatus() {
      try {
        const response = await this.$http.get("api/v2/talents/public/show");
        const { is_public = undefined } = response.data.data;

        if (!is_public) {
          this.is_public = false;
          this.receive_email = false;
        } else {
          this.is_public = true;
          this.receive_email = true;
        }
      } catch (error) {
        alert(error);
      }
    },
    async fetchSimilarVacancies() {
      this.isLoadingSimilar = true;
      const timerPromise = new Promise(resolve => setTimeout(resolve, this.similarLoadingMinimumTime));
      try {
        const response = await this.$http.get(
          `/api/v2/vacancies/similar`
        );
        await Promise.all([response, timerPromise]);
        
        this.isLoadingSimilar = false;

        const similars = get(response, 'data', []);

        this.similar_pagination_total = get(similars, 'last_page', null);
        this.similar_pagination_path = get(similars, 'path', '');
        this.similar_pagination_current = get(similars, 'current_page', null);
        this.similar_total = get(similars, 'total', 0);
        this.similars = get(similars, 'data', []);
        this.similars_error = false;
      } catch (error) {
        await timerPromise;
        this.isLoadingSimilar = false;
        this.similars_error = true;
      }
    },
    async onCancel() {
      try {
        await this.$http.post("api/v2/talents/public/destroy-public");
        this.is_public = false;
        this.receive_email = false;

        // alert("Alteração realizada com sucesso!");
        this.$vs.notify({
            title: "Alteração realizada com sucesso!",
            text: "Você não faz mais parte da Base Recrutei.",
            iconPack: "feather",
            icon: "icon-check",
            color: "success"
          });
      } catch (error) {
        alert(error);
      }
    },
    fetchSimilarPagination(page) {
      this.$vs.loading({ text: "Carregando..." });

      this.$http
        .get(`${this.similar_pagination_path}?page=${page}`)
        .then((response) => {
          this.$vs.loading.close();

          const similars = get(response, 'data', []);

          this.similar_total = similars.total;
          this.similar_pagination_total = get(similars, 'last_page', null);
          this.similar_pagination_path = get(similars, 'path', '');
          this.similar_pagination_current = get(similars, 'current_page', null);
          this.similars = get(similars, 'data', []);
          this.similar_total = get(similars, 'total', 0);
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    openNewTab() {
      window.open('https://bit.ly/3F0Gvlp', '_blank');
    },
    openNewTabTelegram() {
      window.open('https://bit.ly/41MlTqG', '_blank');
    },
    openNewTabSearch(){
      window.open('https://bit.ly/3Mfje1K', '_blank');
    },
    changeButton(i) {
      if (i === 1 && this.buttons[0].activated) {
        this.buttons[0].activated = !this.buttons[0].activated;
        this.buttons[i].activated = !this.buttons[i].activated;
      } else {
        this.buttons[1].activated = !this.buttons[1].activated;
        this.buttons[i].activated = !this.buttons[i].activated;
      }
    },
  },
  created() {
    this.fetchSimilarVacancies();
    this.fetchPublicStatus();
  },
  beforeDestroy() {
    if (this.similarLoadingInterval !== null) {
      clearInterval(this.similarLoadingInterval);
    }
  },
  components: { VacancySimilarCard, VacancySimilarMobileCard, VacancyEmptyCard },
};
</script>

<style lang="scss">
.coll-header {
  display: flex;
  align-items: center;
}
.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: white;
  margin-left: 0.5rem;
  border-radius: 25%;
  background-color: blueviolet;
}
.portal-title {
  text-align: center;
  font-size: 22px;
  margin-top: 10px;
  margin-bottom: 40px;
  font-weight: 500;
}
.portal-description {
  text-align: justify;
  margin-bottom: 20px;
}
.portal-question {
  font-weight: bold;
}
.checkboxes {
  margin-top: 25px;
  font-size: 18px;
  align-content: flex-end;
}

.checkbox-group {
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.checkbox {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.checkbox-danger {
  font-size: 11px !important;
  color: #ea5455;
  margin-left: 25px;
}

.portal-btn {
  background-color: rgb(34, 34, 36);
  margin-top: 30px;
  padding: 10px;
  border: 1px #fff solid;
  color: white;
  margin-bottom: 30px;
}

.button-group {
  width: 250px;
  margin: 20px 0;
  display: flex;
  flex-direction: column;

  button {
    margin: 5px 0;
  }
}

.similar-loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;

  .similar-loading-bar {
    width: 327px;
    height: 16px;
    background-color: #EBECF0;
    border-radius: 16px;
  }
  .similar-loading-percentage {
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    letter-spacing: 0.02em;
    text-align: center;
    color:#7A869A;
  }
  .similar-loading-bar-fill {
    background-color: #8777D9;
    border-radius: 16px;
    height: 16px;
    transition: all 0.5s ease-in-out;
  }
  .similar-loading-text {
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: center;
    color: #42526E
  }
}

.buttons-wrapper {
  display: flex;
  justify-content: center;
  margin: 20px 0 30px 0;

  button {
    width: 150px;
    background: #fff;
    padding: 8px;
    border-radius: 3px 0 0 3px;
    border: 1px solid;
    font-weight: 500;
    cursor: pointer;
  }

  button:nth-child(2) {
    border-radius: 0 3px 3px 0;
  }

  .activated {
    background: #fff;
    color: #1551b1;
  }

  .desactivated {
    background: #fafafa;
    color: #cecece;
  }
}
</style>
